import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Main from 'components/Layout/Main';
import { successToast, errorToast } from 'actions';
import routes from 'routes';
import AccessControl from 'components/RBAC/AccessControl';
import permissions from 'permissions';
import Forbidden from 'components/Forbidden';
import UserAgentForm from './UserAgentForm';

function CreateUserAgentContainer(props) {


    return (
        <Main>

            <AccessControl allowedPermissions={[permissions.brands.list]} noAccess={() => <Forbidden />}>
                    <UserAgentForm />
            </AccessControl>
        </Main>
    );
}

const mapDispatchToProps = dispatch => ({
    successToast: msg => dispatch(successToast(msg)),
    errorToast: msg => dispatch(errorToast(msg))
});

export default connect(null, mapDispatchToProps)(CreateUserAgentContainer);